"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _groupTermsBy = _interopRequireDefault(require("./groupTermsBy"));

var _Term = _interopRequireDefault(require("../Term"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * ToSentences does the following:
 * 1) groups terms  and series of terms by whether or not they are puct
 *     --- [[word], [punct], [word, word, word,word], [punct] ....]
 * 2) merges each punct with the word series before it.
 * 3) returns each word series as the child of a single term, 'by sentence'
 *
 * note this doesn't guarantee that each word group HAS punctuation. If the series
 * is all words, or the last word is not punct, then the last (or maybe only) series might not have
 * a punct.
 *
 * @param source
 * @returns {Term}
 */
function toSentences(source) {
  if (!Array.isArray(source)) throw new Error('mergePunct passed non-array');
  var byIsPunct = (0, _groupTermsBy["default"])(source, function (term) {
    return term && term.isMeta && term.meta === 'punc' && term.value === '.';
  });
  byIsPunct.forEach(function (group, index) {
    if (index && group.key) {
      var prevGroup = byIsPunct[index - 1];

      if (prevGroup) {
        prevGroup.push(group, true); // merge the punctuation content onto the previous group, emptying it.
      }
    }
  });

  var sValue = _(byIsPunct).reject('key').map('terms').map(function (value) {
    return new _Term["default"]({
      props: {
        type: 'sentence'
      },
      value: value
    });
  }).value();

  return new _Term["default"]({
    props: {
      type: 'by sentence'
    },
    value: sValue
  });
}

var _default = toSentences;
exports["default"] = _default;